import React from "react";
import { withRouter } from "react-router-dom";
import style from "./mobileSnappShopCard.module.scss";
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas"
import momentJalaali from 'moment-jalaali';

const MobileSnappShopCard = (props) => {

    const defineIconColor = (inBuyBox, robotActive) => {
        let classname = 'logIconWrapper'
        if (robotActive) {
            if (inBuyBox) {
                classname = 'logIconWrapper_green'
            } else {
                classname = 'logIconWrapper_red'
            }
        }
        return classname
    }

    const determinIcon = (inBuyBox, robotActive) => {
        let icon = 'q'
        if (robotActive) {
            if (inBuyBox) {
                icon = 'f'
            } else {
                icon = 'n'
            }
        }
        return icon
    }

    const determinBGColor = (inBuyBox, robotActive, hasError) => {
        let bg = 'notConnectedBG'
        if (robotActive) {
            if (hasError) {
                bg = 'hasError'
            } else {
                if (inBuyBox) {
                    bg = 'inBuyBoxBG'
                } else {
                    bg = 'outOfBuyBoxBG'
                }
            }
        }
        return bg
    }

    return (
        <>
            <div
                className={`${style.wrapper} ${style[determinBGColor(((props.data.error_text && props.data.error_text != '' && props.data.robot && props.data.robot.active && props.data.snapp_active) ? false : props.data.in_buybox), (props.data.robot && props.data.robot.active && props.data.snapp_active), (props.data.error_text && props.data.error_text != '' && props.data.robot && props.data.robot.active && props.data.snapp_active))]}`}
            >
                <div className={style.header}>
                    <div
                        className={style[defineIconColor((props.data.error_text && props.data.error_text != '' ? false : props.data.in_buybox), (props.data.robot && props.data.robot.active && props.data.snapp_active))]}
                    >
                        {determinIcon((props.data.error_text && props.data.error_text != '' ? false : props.data.in_buybox), (props.data.robot && props.data.robot.active && props.data.snapp_active))}
                    </div>
                    <a
                        href={`https://snappshop.co${props.data.url}`}
                        className={style.cardTitle}
                        target="_blank"
                    >
                        <p className={style.title}>{props.data.title}</p>
                        {props.data.variation_attributes.length > 0 && <span>{props.data.variation_attributes.length > 0 ? '(' + props.data.variation_attributes[0].value.title + ')' : ''}</span>}
                    </a>
                </div>

                <div className={style.seprator}></div>

                <div className={style.rowStyle}>
                    <p className={style.title}>وضعیت ربات</p>
                    <p className={style.value}>{(props.data.robot && props.data.robot.active) ? (!props.data.snapp_active ? 'غیرفعال در پنل' : 'فعال') : 'غیرفعال'}</p>
                </div>
                <div className={style.rowStyle}>
                    <p className={style.title}>قیمت فروش</p>
                    <p className={style.value}>{toPersianNumber(numberWithCommas(props.data.price))} ریال</p>
                </div>
                <div className={style.rowStyle}>
                    <p className={style.title}>آخرین به‌روزرسانی</p>
                    <p className={style.value}>{toPersianNumber(momentJalaali(props.data.robot ? props.data.robot.last_change_price : props.data.created_at).format('HH:mm'))} - {toPersianNumber(momentJalaali(props.data.robot ? props.data.robot.last_change_price : props.data.created_at).format('jYYYY/jM/jD'))}</p>
                </div>
            </div>
            {(props.data.error_text && props.data.error_text != '' && (props.data.robot && props.data.robot.active)) &&
                <div className={style.errorText}>
                    <p>{toPersianNumber(props.data.error_text)}</p>
                </div>
            }
        </>
    )
}

export default withRouter(MobileSnappShopCard);



